import axios from 'axios'

function install(Vue, options) {
	Vue.prototype.$count = function() {
		axios.post('./api')
			.then( (r) => {})
			.catch( (e) => console.log('error', e))
	}

}

export default install